module.exports = __webpack_public_path__ + "static/media/TOMCHILOGO.c9dfd6e7.png";